import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export function useProviderDetailsState() {
  const { user } = useSelector((state: RootState) => state.auth);
  const {
    lastFetchedProvider: provider,
    loading: providersLoading,
    list: clinicalProviderList,
    allProvidersList,
  } = useSelector((state: RootState) => state.providers);
  const { list: payorProviderCreds, loading: credsLoading } = useSelector(
    (state: RootState) => state.payorProviderCredentials,
  );
  const { list: clientAssignments = [], loading: clientAssignmentsLoading } = useSelector(
    (state: RootState) => state.providerAssignment,
  );

  // Skeletons only for the initial fetch — in-place updates also set providers.loading.
  const loading = providersLoading && !provider;

  return {
    user,
    provider,
    loading,
    clinicalProviderList,
    allProvidersList,
    payorProviderCreds,
    credsLoading,
    clientAssignments,
    clientAssignmentsLoading,
  };
}
